/**
 * Beta Badge Component
 * Shows a small badge icon for beta users
 * Image attribution: Vecteezy.com (see Credits page)
 */

const BetaBadge = ({ size = 'sm', className = '' }) => {
  const sizes = {
    xs: 'w-4 h-4',   // 16px
    sm: 'w-5 h-5',   // 20px  
    md: 'w-6 h-6',   // 24px
    lg: 'w-8 h-8',   // 32px
  };

  return (
    <img 
      src="/images/beta-badge.png"
      alt="Founding Member - Image from Vecteezy.com"
      className={`inline-block ${sizes[size] || sizes.sm} ${className}`}
    />
  );
};

export default BetaBadge;
